module.exports = __webpack_public_path__ + "static/media/r14.091bec12.jpg";